import { render, staticRenderFns } from "./FooterSite.vue?vue&type=template&id=5f90ce9c&"
import script from "./FooterSite.vue?vue&type=script&lang=js&"
export * from "./FooterSite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports